module.exports = __webpack_public_path__ + "static/media/6.IPhone_5.e83ec53c.png";